import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
  ,
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('../views/ContactsView.vue')
  }
  ,
  {
    path: '/articles',
    name: 'articles',
    component: () => import('../views/ArticlesView.vue')
  },
  {
    path: '/callus',
    name: 'callus',
    component: () => import('../views/CallUsView.vue')
  }
  ,
  {
    path: '/highschool',
    name: 'highschool',
    component: () => import('../views/HighschoolView.vue')
  }
  ,
  {
    path: '/middleschool',
    name: 'middleschool',
    component: () => import('../views/MiddleschoolView.vue')
  }
  ,
  {
    path: '/scholarship',
    name: 'scholarship',
    component: () => import('../views/ScholarshipView.vue')
  }
  ,
  {
    path: '/languagecourses',
    name: 'languagecourses',
    component: () => import('../views/LanguageCoursesView.vue')
  }
  ,
  {
    path: '/countries',
    name: 'countries',
    component: () => import('../views/CountriesView.vue')
  }
  ,
  {
    path: '/appform',
    name: 'appform',
    component: () => import('../views/ApplicationFormView.vue')
  },
  {
    path: '/form_sent',
    name: 'form_sent',
    component: () => import('../views/FormSentView.vue')
  },

]

// const router = new VueRouter({
//   routes
// })

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to) {
    if (to.hash) {
      return window.scrollTo({ top: document.querySelector(to.hash).offsetTop, behavior: 'smooth' });
    }
    return window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});

export default router
